<ui-disclosure-panel title="Aktywność" hint="Ostatnia aktywność" [open]="true">
  <wishlist-activity-feed
    [activities]="activities()"
    title="Ostatnia aktywność"
    emptyText="Brak zapisanej aktywności dla tej wishlisty."
  />
</ui-disclosure-panel>
